import { ControlGroup, FormGroup, HTMLSelect } from "@blueprintjs/core";
import * as React from "react";
import { connect } from "react-redux";
import { firestore } from "../firebase";
import { IState } from "../store";
import { GetModels, getModels } from "../store/actions";
import { IStrings } from "../store/reducers/strings";

interface IYmmDispatchProps {
  onGetModels: GetModels;
}

interface IYmmOwnProps {
  businessId?: string | null;
  siteId?: string | null;
  disabled?: boolean;
  onChange: (vehicle: IYmmVehicle, change: YmmChange) => void;
  strings: IStrings;
}

interface IYmmStateProps {
  makes: string[];
  models: string[];
}

type YmmProps = IYmmDispatchProps & IYmmOwnProps & IYmmStateProps;

interface IYmmState {
  loadingMakes: boolean;
  loadingModels: boolean;
  make: string;
  model: string;
  yearMax: string;
  yearMin: string;
  years: number[];
}
export type YmmChange = "make" | "yearMax" | "yearMin" | "model";
export interface IYmmVehicle {
  make: null | string;
  yearMax: null | number;
  yearMin: null | number;
  model: null | string;
}

export class Ymm extends React.PureComponent<YmmProps, IYmmState> {
  private defaultMake = "SELECT MAKE";
  // private defaultMake = "Select Make";
  private defaultModel = "SELECT MODEL";
  private defaultYearMin = "1960";
  private defaultYearMax = new Date().getFullYear().toString();

  private yearMax = new Date().getFullYear() - 10;

  private initialState = {
    loadingMakes: false,
    loadingModels: false,
    make: this.defaultMake,
    model: this.defaultModel,
    yearMax: this.defaultYearMax,
    yearMin: this.defaultYearMin,
    years: [],
  };

  constructor(props: YmmProps) {
    super(props);

    const { businessId } = props;
    this.state = this.initialState;
    if (businessId && (businessId === "oSzdmh7JC5wUrIwcETjR" || businessId === "zTaYJYiGLHRy9PNwR671" || businessId === "3DmMhzu7mCa3hpLUEbp9")) {
      // if Central Florida Pick and Pay OR US Auto OR U pull U Save, add all years 2010 -> current year
      this.yearMax = new Date().getFullYear();
    }
  }

  public async componentDidMount() {
    await this.enableYearRange();
    this.getYearRange();

    
    const { yearMax, yearMin, model } = this.state;
    const { onChange } = this.props;
    const maxInt = parseInt(yearMax, 10);
    const minInt = parseInt(yearMin, 10);
    this.handleMake(this.props.makes[0]);

    onChange(
      {
        make: this.props.makes[0],
        model: model === this.defaultModel ? null : model,
        yearMax: isNaN(maxInt) ? null : maxInt,
        yearMin: isNaN(minInt) ? null : minInt,
      },
      'make'
    );

  }

  public getYearRange = () => {
    const years: number[] = [1960];

    for (let i = 1980; i <= this.yearMax; i += 1) {
      years.push(i);
    }
    if (!years.includes(this.yearMax)) {
      years.push(this.yearMax);
    }

    if (!years.includes(new Date().getFullYear())) {
      years.push(new Date().getFullYear());
    }

    this.setState({ years });

    return years;
  };

  public reset = () =>
    this.setState(this.initialState, () => this.getYearRange());

  public render() {
    const { disabled, models, strings } = this.props;
    let { makes } = this.props;
    const { loadingModels, make, yearMax, yearMin, model, years } = this.state;
    const yearMaxs = (() => {
      const minInt = parseInt(yearMin, 10);
      const minFilter = (year: number) =>
        !isNaN(minInt) ? year >= minInt : year;

      return [...years.filter(minFilter)];
    })();
    const yearMins = (() => {
      const maxInt = parseInt(yearMax, 10);
      const maxFilter = (year: number) =>
        !isNaN(maxInt) ? year <= maxInt : year;
      return [...years.filter(maxFilter)];
    })();
    const yearMinsDisabled = disabled;
    const makesDisabled = false;
    const modelsDisabled =
      disabled || loadingModels || make === this.defaultMake;
    const modelsError = !modelsDisabled && models.length === 0;

    const makesArray = [
                        'ALFA-ROMEO',
                        'ASTON MARTIN',
                        'BENTLEY',
                        'FERRARI',
                        'LAMBORGHINI',
                        'MASERATI',
                        'MAYBACH',
                        'ROLLS ROYCE',
                        ];

    makes = makes.filter((item) => {
      return !makesArray.includes(item);
    });

    return (
      <>
        <FormGroup label={strings.year} labelInfo={strings.yearRange}>
          <div id="minmaxx-style">
            <ControlGroup vertical={false}>
              <HTMLSelect
                disabled={yearMinsDisabled}
                fill={true}
                name="yearMin"
                onChange={this.handleSelect}
                options={yearMins}
                value={yearMin}
              />
              <br />
              <HTMLSelect
                fill={true}
                name="yearMax"
                onChange={this.handleSelect}
                options={yearMaxs}
                value={yearMax}
              />
            </ControlGroup>
          </div>
        </FormGroup>
        <div style={{ display:"flex" }}>
          <div style={{ width:"50%" }}>
            <FormGroup label={strings.make}>
              <HTMLSelect
                disabled={makesDisabled}
                fill={true}
                name="make"
                onChange={this.handleSelect}
                options={[...makes]}
                // options={[this.defaultMake, ...makes]}
                value={make}
                id="make_option"
              />
            </FormGroup>
          </div>
          <div style={{ width:"50%" }}>
            <FormGroup
              intent={modelsError ? "danger" : undefined}
              helperText={modelsError ? strings.modelError : undefined}
              label={strings.model}
            >
              <HTMLSelect
                disabled={modelsDisabled}
                fill={true}
                name="model"
                onChange={this.handleSelect}
                // options={[...models].sort()}
                options={[this.defaultModel, ...models.sort()]}
                value={model}
              />
            </FormGroup>
          </div>
        </div>
      </>
    );
  }
  private handleSelect = ({
    currentTarget: { name, value },
  }: React.ChangeEvent<HTMLSelectElement>) => {
    const { onChange } = this.props;
    let change: YmmChange = "yearMin";
    let { make, yearMax, yearMin, model } = this.state;

    if (name === "yearMax") {
      change = name;
      yearMax = value;
      this.handleYearMax(value);
    }
    if (name === "yearMin") {
      change = name;
      yearMin = value;
      this.handleYearMin(value);
    }
    if (name === "make") {
      change = name;
      make = value;
      this.handleMake(value);
    }
    if (name === "model") {
      change = name;
      model = value;
      this.handleModel(value);
    }

    const maxInt = parseInt(yearMax, 10);
    const minInt = parseInt(yearMin, 10);

    onChange(
      {
        make: make === this.defaultMake ? null : make,
        model: model === this.defaultModel ? null : model,
        yearMax: isNaN(maxInt) ? null : maxInt,
        yearMin: isNaN(minInt) ? null : minInt,
      },
      change
    );
  };

  private async enableYearRange(){
    const { businessId } = this.props;
    if(businessId){
      const business = await firestore
      .collection("businesses")
      .doc(businessId)
      .get();
      if (business.exists) {
        const businessData = business.data();
        if (businessData) {
          if(businessData.modelYearRangeSwitch){
            this.yearMax = new Date().getFullYear();
          }else{
            this.yearMax = new Date().getFullYear() - 10;
          }
        }
      }
  
    }
  }

  private handleYearMax = (yearMax: string) => this.setState({ yearMax });
  private handleYearMin = (yearMin: string) => this.setState({ yearMin });
  private handleMake = async (make: string) => {
    const { businessId, siteId } = this.props;
    const { yearMax, yearMin } = this.state;
    const { onGetModels } = this.props;
    console.log("years: " + yearMax + yearMin);

    this.setState({ loadingModels: true, make });

    if (make !== this.defaultMake) {
      await onGetModels({ make, yearMax, yearMin, businessId, siteId });
    }

    this.setState({ loadingModels: false });
  };
  private handleModel = (model: string) => this.setState({ model });
}
const mapStateToProps = ({
  inventory: { makes, yearMax, yearMin, models },
}: IState) => ({ makes, yearMax, yearMin, models });

const mapDispatchToProps = {
  onGetModels: getModels,
};

export default connect<IYmmStateProps, IYmmDispatchProps, IYmmOwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(Ymm);



// WEBPACK FOOTER //
// ./src/components/Ymm.tsx